import { useContext } from 'react'
import { WeekScope, WeekScopeContext } from 'providers/WeekScopeProvider'

/**
 * The week currently rendered on screen. Deliberately has no fallback: a
 * component reading a week scope that nobody established is a bug, and
 * silently handing it the signed-in user's start day produces query windows
 * that look right but are shifted off the columns beside them.
 */
export const useWeekScope = (): WeekScope => {
  const scope = useContext(WeekScopeContext)

  if (!scope) {
    throw new Error(
      'useWeekScope must be rendered within a week scope. Establish one with useSignedInUsersWeekScope or useViewedUsersWeekScope.',
    )
  }

  return scope
}
